import { Navigate } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { EUserRoles } from '@/types';
import { homepageByRole, SESSION_STORAGE_KEYS } from '@/utils/constants';
import { getLinkToLogin } from '@/utils/getLinkToLogin';
import { isSafeRedirect } from '@/utils/safeRedirect';

export const AuthCheckLayout = () => {
  const { isSuperAdmin, role } = useUsersStore((state) => ({
    isSuperAdmin: state.checkIsSuperAdmin(),
    role: state.role,
  }));
  const userRole = isSuperAdmin ? EUserRoles.ADMIN : role;

  const returnPath = sessionStorage.getItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);

  if (returnPath && userRole) {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);
    if (isSafeRedirect(returnPath)) {
      return <Navigate to={returnPath} replace />;
    }
  }

  return (
    <Navigate
      to={userRole ? homepageByRole[userRole] : getLinkToLogin()}
      replace
    />
  );
};
